import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowDownToLineIcon, ArrowUpRightIcon, CalendarCheckIcon } from 'lucide-react';
import { PortraitFrame } from '../components/PortraitFrame';
import { profile, sections } from '../data/profile';
import { metrics } from '../data/metrics';
const ease = [0.23, 1, 0.32, 1] as const;
export function Home() {
  return <>
      <section className="bg-navy text-paper" data-id="element-273" data-mp="1ziqqpcashcgg">
        <div className="mx-auto max-w-shell px-6 pb-20 pt-16 lg:px-10 lg:pb-24 lg:pt-24" data-id="element-274" data-mp="1zk1uhc48ik7k">
          <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-275" data-mp="24j4rqadz3m4z">
            <motion.div initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            ease
          }} className="w-full max-w-[19rem]" data-id="element-276" data-mp="29ek5z3fw7k1x">
              <PortraitFrame data-id="element-277" data-mp="3kxmrst2lqa5f" />
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 16
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.08,
            ease
          }} className="mt-12 w-full" data-id="element-278" data-mp="3ovkjc2juh8bz">
              {/* Engraved nameplate */}
              <div className="relative border-y border-gold/40 py-7" data-id="element-279" data-mp="2qy2ffayhjjad">
                <span aria-hidden="true" className="absolute left-1/2 top-0 h-1.5 w-1.5 -translate-x-1/2 -translate-y-1/2 rotate-45 border border-gold-soft/70 bg-navy" data-id="element-280" data-mp="2mx0gywce7b9g" />
                <span aria-hidden="true" className="absolute bottom-0 left-1/2 h-1.5 w-1.5 -translate-x-1/2 translate-y-1/2 rotate-45 border border-gold-soft/70 bg-navy" data-id="element-281" data-mp="2d6p1qdn9dfn9" />
                <h1 className="font-display text-5xl font-light tracking-tight lg:text-6xl" data-id="element-282" data-mp="23a2jzxq8b4pg">
                  {profile.name}
                </h1>
                <p className="mt-4 text-[11px] uppercase tracking-overline text-gold-soft" data-id="element-283" data-mp="1z98s6t9o15ra">
                  Senior Vice President, Product Management · Corporate Development Advisor
                </p>
              </div>

              <p className="mx-auto mt-8 max-w-2xl font-display text-xl font-light leading-relaxed text-white/90 lg:text-2xl" data-id="element-284" data-mp="1omtzu7exzp1c">
                Strategic Product Leader
                <span className="text-white/35" data-id="element-285" data-mp="1aovzi5xght4u"> | </span>
                SVP &amp; Board Advisor
                <span className="text-white/35" data-id="element-286" data-mp="1fnh1a9scwkve"> | </span>
                <span className="text-gold-soft" data-id="element-287" data-mp="23c9s5ru4g2j5">
                  Transforming Enterprise SaaS, AI &amp; Data Ecosystems
                </span>
              </p>

              <p className="mx-auto mt-6 max-w-xl text-[15px] leading-relaxed text-white/60" data-id="element-288" data-mp="1tlorlyuw0nxl">
                {profile.subheadline}
              </p>

              <div className="mt-10 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center" data-id="element-289" data-mp="1yixe2bn2je4n">
                <a href={`mailto:${profile.email}?subject=Executive%20Bio%20Request`} className="inline-flex items-center justify-center gap-2.5 bg-gold-bright px-7 py-4 text-[13px] font-medium uppercase tracking-overline text-navy transition-colors duration-150 ease-out hover:bg-gold-soft" data-id="element-290" data-mp="2m7zrt8el0mtv">
                  <ArrowDownToLineIcon className="h-4 w-4" aria-hidden="true" data-id="element-291" data-mp="oedthjmmr8t5" />
                  Download Executive Bio
                </a>
                <Link to="/contact" className="inline-flex items-center justify-center gap-2.5 border border-white/25 px-7 py-4 text-[13px] font-medium uppercase tracking-overline text-paper transition-colors duration-150 ease-out hover:border-white/60 hover:bg-white/5" data-id="element-292" data-mp="kdc37saoy73b">
                  <CalendarCheckIcon className="h-4 w-4" aria-hidden="true" data-id="element-293" data-mp="5l9zty9ewvyj" />
                  Schedule Consultation
                </Link>
              </div>
            </motion.div>
          </div>
        </div>

        <div className="border-t border-white/10" data-id="element-294" data-mp="1c3yox1zyzyjb">
          <dl className="mx-auto grid max-w-shell grid-cols-1 px-6 sm:grid-cols-2 lg:grid-cols-4 lg:px-10" data-id="element-295" data-mp="1c36rrmqq5sqx">
            {metrics.map((metric, i) => <motion.div key={metric.value} initial={{
            opacity: 0,
            y: 12
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.4,
            delay: 0.2 + i * 0.05,
            ease
          }} className={`py-8 lg:px-8 ${i % 2 === 0 ? 'sm:pr-8' : 'sm:border-l sm:border-white/10 sm:pl-8'} ${i < metrics.length - 1 ? 'border-b border-white/10 sm:border-b-0' : ''} ${i < 2 ? 'sm:border-b sm:border-white/10 lg:border-b-0' : ''} ${i === 2 ? 'lg:border-l lg:border-white/10 lg:pl-8' : ''} lg:first:pl-0 lg:last:pr-0`} data-id="element-296" data-mp="2ccq2yu9wrs4d" data-mpi={i}>
                <dt className="font-display text-2xl text-paper lg:text-[1.75rem]" data-id="element-297" data-mp="350vj13q0osxv">
                  {metric.value}
                </dt>
                <dd className="mt-2 max-w-[22ch] text-[13px] leading-relaxed text-white/55" data-id="element-298" data-mp="3e222nlnyqjvc">
                  {metric.label}
                </dd>
              </motion.div>)}
          </dl>
        </div>
      </section>

      <section className="bg-paper py-20 lg:py-24" data-id="element-299" data-mp="ycbnvwrsri0j">
        <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-300" data-mp="tea75ihufus8">
          <p className="text-[11px] uppercase tracking-overline text-gold" data-id="element-301" data-mp="tetph0beol6s">The Dossier</p>
          <h2 className="mt-5 max-w-xl font-display text-3xl font-light leading-tight text-navy" data-id="element-302" data-mp="ogif8oh788o1">
            Ten sections covering the full executive record
          </h2>

          <ul className="mt-10 grid grid-cols-1 gap-x-12 lg:grid-cols-2" data-id="element-303" data-mp="1h3cpyto7rtob">
            {sections.slice(1).map(s => <li key={s.path} className="border-t border-navy/10" data-id="element-304" data-mp="1cbuxyv4653fh">
                <Link to={s.path} className="group flex items-start gap-5 py-6 transition-colors duration-150 ease-out hover:bg-white" data-id="element-305" data-mp="17ekzyr2prjg1">
                  <span className="mt-1 font-display text-sm text-gold" data-id="element-306" data-mp="2030df9675tp9">{s.number}</span>
                  <span className="flex-1" data-id="element-307" data-mp="3uakmcaz2cqbw">
                    <span className="flex items-center gap-2 font-display text-xl font-light text-navy" data-id="element-308" data-mp="3ubnfyqnrt6vi">
                      {s.title}
                      <ArrowUpRightIcon className="h-4 w-4 text-gold opacity-0 transition-opacity duration-150 ease-out group-hover:opacity-100" aria-hidden="true" data-id="element-309" data-mp="28w5lm2ko4yo" />
                    </span>
                    <span className="mt-1.5 block text-[14px] leading-relaxed text-steel" data-id="element-310" data-mp="3altqwkcfx5uz">
                      {s.blurb}
                    </span>
                  </span>
                </Link>
              </li>)}
          </ul>
        </div>
      </section>
    </>;
}